controllers.controller('CreditCardController', [
    '$scope', '$state', '$filter', '$timeout', '$ionicLoading', '$ionicHistory', '$q', 'LocaleService', 'config',
    'Validator', 'Storage', 'constants', 'ServerTimeService', 'Utils', 'UserService', 'API', 'ErrorService', '$interval', '$cookies',
    function ($scope, $state, $filter, $timeout, $ionicLoading, $ionicHistory, $q, LocaleService, config, Validator,
              Storage, Const, ServerTimeService, Utils, UserService, API, ErrorService, $interval, $cookies) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.user = UserService.get();
        $scope.paymentMethods = Storage.get('paymentMethods') || [];
        $scope.constants = Const;
        $scope.depositValue = Storage.get('depositValue');
        $scope.validator = Validator.getPattern;
        $scope.minDate = ServerTimeService.time;
        $scope.creditCard = {
            value: $scope.depositValue.visual,
            holder: $scope.user.firstName + ' ' + $scope.user.lastName
        };
        $scope.paymentPopup = null;

        var paymentRequest = {
            amount: 0,
            currency: $scope.user.activeTradingAccount.currency,
            type: '',
            number: '',
            cvv: '',
            expiryMonth: null,
            expiryYear: null,
            holder: $scope.user.firstName + ' ' + $scope.user.lastName,
            country: $scope.user.country,
            address: $scope.user.address,
            city: $scope.user.city,
            phone: $scope.user.phone,
            state: '',
            postcode: $scope.user.postCode,
            phoneCountryCode: '',
            phoneAreaCode: '',
            platform: Const.platformById.webMobile
        };

        var cardTypeBlueprint = {
            visaelectron: 'Visa Electron',
            maestro: 'Maestro',
            forbrugsforeningen: '',
            dankort: '',
            visa: 'Visa',
            mastercard: 'MasterCard',
            amex: 'American Express',
            dinersclub: 'Diners Club',
            discover: '',
            unionpay: '',
            jcb: 'JCB'
        };

        $scope.config = {
            digits: 0,
            step: 50,
            min: $scope.depositValue.minimum,
            max: $scope.depositValue.maximum
        };
        $scope.changeStep = config.stepChange;
        $scope.listAmounts = [];

        var result = [];

        Array(5).fill(null).reduce(function (acc, cur, index) {
            var tmp = Math.ceil(acc * Const.depositMultipliers[index]);
            result.push(tmp);
            return tmp;
        }, $scope.depositValue.visual <= $scope.config.min ? $scope.config.min : $scope.depositValue.visual);

        if (result.length > 0) $scope.listAmounts = result;

        $scope.confirm = function (form) {
            if (!form.$valid) return;
            var expiryMonth = $filter('date')($scope.creditCard.date, "MM");
            var expiryYear = $filter('date')($scope.creditCard.date, "yyyy");
            paymentRequest.type = '';
            paymentRequest.number = $scope.creditCard.number;
            paymentRequest.cvv = $scope.creditCard.cvv;
            paymentRequest.expiryMonth = parseInt(expiryMonth, 10);
            paymentRequest.expiryYear = parseInt(expiryYear, 10);
            paymentRequest.holder = $scope.creditCard.holder;
            paymentRequest.amount = parseFloat($scope.creditCard.value);
            paymentRequest.remarketing = $cookies.get('remarketing') || '';
            return doPayment();
        };

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'CreditCardController',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        function updatePopup(response) {
            return $q(function (resolve, reject) {
                var timer = $interval(isPopupClosed, 100);
                API.subscribe('depositConfirm', clearPayment);

                var popupOptions = ['toolbar=no','status=no','menubar=no','scrollbars=no','resizable=no',
                    'left=10000','top=10000', 'width=10', 'height=10', 'visible=none'].join(',');

                if (response.RedirectURL && !response.PostData) {
                    $scope.paymentPopup = window.open(response.RedirectURL, '_blank', popupOptions);
                    //$scope.paymentPopup = window.open('templates/deposit-inapp.html', '_blank', popupOptions);
                }

                function clearPayment(confirmResponse) {
                    API.unsubscribe('depositConfirm');
                    $scope.paymentPopup && $scope.paymentPopup.close();
                    try {
                        checkResponse(confirmResponse);
                    } catch (e) {
                        reject(e);
                    }
                    resolve(confirmResponse);
                }

                function isPopupClosed() {
                    if ($scope.paymentPopup && $scope.paymentPopup.closed) {
                        $interval.cancel(timer);
                        $scope.paymentPopup = null;
                        $ionicLoading.hide();
                        $scope.paymentMethods.length > 1 ? $state.go('root.app.wallet') : $state.go( 'root.app.assets');
                    }
                }

                /*function postData() {
                    var script = "postData('" + response.RedirectURL + "','" + JSON.stringify(response.PostData) + "')";
                    $scope.paymentPopup.executeScript({code: script});
                }*/
            });
        }


        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        function doPayment() {
            $ionicLoading.show();

            return API.creditCardDeposit(paymentRequest)
                .then(checkResponse)
                .then(function (response) {
                    if (response.RedirectURL && response.RedirectURL.length > 0) {
                        return updatePopup(response);
                    }
                    return response;
                })
                .then(function (response) {
                    $scope.paymentPopup && $scope.paymentPopup.close();
                    $ionicLoading.hide();

                    $cookies.get('remarketing') && $cookies.remove('remarketing');
                    $scope.modal.textTitle = LocaleService.translation.messages.depositSuccess;
                    $scope.modal.isError = false;
                    $scope.modal.actionText = LocaleService.translation.startTrading;
                    $scope.modal.back = 'root.app.assets';

                    $scope.modal.transactionId = response.transactionId;
                    $scope.modal.date = Date.now();
                    $scope.modal.amount = Const.currencySymbols[response.currency] + ' ' + response.amount;
                    $scope.modal.method = 'Credit Card **** ' + (response.creditCardLast4Digits || response.lastDigits);
                    $scope.modal.state = true;
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.textTitle = LocaleService.translation.messages.depositFailed;
                    $scope.paymentPopup && $scope.paymentPopup.close();
                    $scope.modal.actionText = LocaleService.translation.tryAgain;
                    $scope.modal.isError = true;
                    $scope.modal.textContent = LocaleService.translation.messages.depositFailedText;
                    $scope.modal.state = true;
                })
        }

        function clear() {
            API.unsubscribe('depositConfirm');
            $scope.creditCard = null;
            $scope.depositValue = null;
            $scope.user = null;
            $scope.paymentPopup = null;
            $scope.user = null;
            $ionicHistory.clearHistory();
        }

        $scope.$on('$ionicView.afterLeave', clear);
        $scope.$on('clear', clear);

    }]);
